module.exports = __webpack_public_path__ + "img/icon-192x192.8422df55.png";